import { render, staticRenderFns } from "./UnitMSPNG1.vue?vue&type=template&id=3b5245c3&scoped=true&"
import script from "./UnitMSPNG1.vue?vue&type=script&lang=js&"
export * from "./UnitMSPNG1.vue?vue&type=script&lang=js&"
import style0 from "./UnitMSPNG1.vue?vue&type=style&index=0&id=3b5245c3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5245c3",
  null
  
)

export default component.exports